
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'twitter': {
    width: 16,
    height: 16,
    viewBox: '0 0 18 15',
    data: '<path pid="0" d="M18 1.775a7.188 7.188 0 0 1-2.121.6A3.786 3.786 0 0 0 17.503.281a7.286 7.286 0 0 1-2.345.918 3.649 3.649 0 0 0-2.7-1.2 3.74 3.74 0 0 0-3.692 3.786 3.891 3.891 0 0 0 .1.863A10.4 10.4 0 0 1 1.254.691a3.849 3.849 0 0 0-.5 1.9 3.813 3.813 0 0 0 1.642 3.152 3.612 3.612 0 0 1-1.672-.474v.047A3.766 3.766 0 0 0 3.686 9.03a3.63 3.63 0 0 1-.973.133 3.618 3.618 0 0 1-.694-.068 3.711 3.711 0 0 0 3.449 2.63 7.292 7.292 0 0 1-4.586 1.622A7.28 7.28 0 0 1 0 13.3 10.273 10.273 0 0 0 5.661 15c6.792 0 10.507-5.77 10.507-10.774 0-.164 0-.328-.011-.49A7.6 7.6 0 0 0 18 1.775z" _fill="#d9d9d9" fill-rule="evenodd"/>'
  }
})
